// extracted by mini-css-extract-plugin
export default {"gallery":"c-p_fb","gallery__header":"c-p_fc","gallery__thumbs":"c-p_fe"};